import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../utils/Auth';
import AnalyticsView from '../../components/AnalyticsView';
import styles from './Analytics.module.css';

export default function Analytics() {
    // ----- STATE INITIALIZATION -----
    const navigate = useNavigate();
    const { activeOrgId, currentUser, liquidQRs, orgObj } = useAuth();
    // ----- END STATE INITIALIZATION -----
    // ----------------------------------------------

    if (currentUser && (orgObj?.hasOwnProperty('plan') && (orgObj?.plan?.plan_id > 2 || orgObj?.plan?.analytics > 1))) {
        return (
            <>
              <div className={styles.wrapper}>
                  <div className={styles.container}>
                      <AnalyticsView 
                        orgId={activeOrgId}
                        orgObj={orgObj}
                        liquidQRs={liquidQRs}
                      />
                  </div>
              </div>
            </>
        );
    } else {
        return (
            <div className={styles.wrapper}>
                <div className={styles.container}>
                    <h1>Analytics</h1>
                    <div className={styles.content}>
                        <p>Upgrade to a plan with Advanced Analytics to view this content.</p>
                    </div>
                    <button className={styles.upgradeBtn} onClick={() => navigate('/organizations/settings')} >Upgrade</button>
                </div>
            </div>
        );
    };
};
